var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2473 15.2473L20.5 20.5M17.2052 10.3526C17.2052 14.1372 14.1372 17.2052 10.3526 17.2052C6.56801 17.2052 3.5 14.1372 3.5 10.3526C3.5 6.56801 6.56801 3.5 10.3526 3.5C14.1372 3.5 17.2052 6.56801 17.2052 10.3526Z",
    stroke: "#CCCFD1",
    strokeWidth: 1.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.9299c06b6b0fd2cf499f7d5f31558ab1.svg";
export { ForwardRef as ReactComponent };